<template>
  <VWidget
    v-if="product.components"
    :title="$t('Bundle Components')"
    class="mt-3"
  >
    <div slot="widget-header-action">
      <v-btn
        flat
        class="text--secondary text-capitalize"
        no-title-update
        @click="dialog = true"
      >
        {{ $t('Add components') }}
      </v-btn>
    </div>

    <v-layout
      slot="widget-content"
      row
      wrap
    >
      <v-flex xs12>
        <v-data-table
          :items="products"
          :headers="headers"
          hide-actions
          item-key="key"
          disable-initial-sort
        >
          <template v-slot:items="{ item }">
            <tr>
              <td>{{ item.name }}</td>
              <td>
                <router-link
                  :to="{
                    name: 'single-product',
                    params: { id: item.id }
                  }"
                  class="text-no-wrap"
                >
                  {{ item.sku }}
                </router-link>
              </td>
              <td>{{ item.inventory.quantity }}</td>
              <td class="text-xs-right">
                <v-flex>
                  <v-text-field
                    :value="bundleQt(item.key)"
                    :label="$t('Quantity')"
                    outline
                    type="number"
                    hide-details
                    class="mx-1"
                    @input="onUpdateBundleQty(item.key, $event)"
                  />
                </v-flex>
              </td>
              <td
                class="pointer"
                @click="onRemoveComponent(item.key)">
                <v-icon>delete</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
      >
        <product-single-select-component-dialog
          v-if="dialog"
          :selected="products"
          @closed="dialog = false"
          @add-product="onAddComponent"
        />
      </v-dialog>
    </v-layout>
  </VWidget>
</template>

<script>
import ProductSingleSelectComponentDialog from '@/modules/Products/components/ProductSingle/ProductSingleSelectComponentDialog'
import randomstr from 'randomstring'

export default {
  name: 'ProductSingleComponents',
  components: { ProductSingleSelectComponentDialog },
  props: {
    product: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      dialog: false,
      products: []
    }
  },

  computed: {
    headers () {
      return [
        { text: this.$t('Name'), sortable: false, value: 'name' },
        { text: this.$t('SKU'), sortable: false, value: 'sku' },
        { text: this.$t('Inventory quantity'), sortable: false, value: 'inventory.quantity' },
        { text: this.$t('Bundle quantity'), sortable: false, value: 'quantity', width: '15%', class: 'text-xs-center' },
        { text: '', sortable: false, width: '1%' }
      ]
    }
  },

  mounted () {
    this.getComponents()
  },

  methods: {
    async getComponents () {
      const res = await this.$http.make('product')
        .where('id', 'like', [...new Set(this.product.components.map(component => component.id))].join(','))
        .getFullData()
      this.products = []
      this.product.components.forEach(component => {
        const found = res.collection.find(el => el.id === component.id)
        const fullProduct = { ...found }
        fullProduct.key = component.key
        fullProduct.quantity = component.quantity
        this.products.push(fullProduct)
      })
    },

    async getComponent (id, key) {
      const res = await this.$http.make('product').find(id)
      const found = this.product.components.find(component => component.key === key)
      if (found) {
        const fullProduct = { ...res }
        fullProduct.key = found.key
        this.products.push(fullProduct)
      }
    },

    bundleQt (key) {
      const component = this.product.components.find(comp => comp.key === key)
      if (component) {
        return component.quantity
      }
    },

    onUpdateBundleQty (key, qt) {
      this.$emit('update-qty', { key, qt })
    },

    onRemoveComponent (key) {
      let found = this.products.findIndex(component => component.key === key)
      if (found > -1) {
        this.products.splice(found, 1)
      }
      this.$emit('remove-component', key)
    },

    onAddComponent (item) {
      const component = {
        id: item.id,
        quantity: 1,
        key: randomstr.generate(16)
      }

      this.$emit('update-components', component)
      this.getComponent(item.id, component.key)
      this.dialog = false
    }
  }
}
</script>
